import React, { Component } from 'react';

export class RangePanel extends Component {
    constructor(props) {
        super(props);
        this.updateValueHandler = this.updateValueHandler.bind(this);
    }

    updateValueHandler = (e) => {
        const { item, updateValue } = this.props;

        if (e.target && /[^0-9.]/.test(e.target.value)) {
            return;
        }

        if (parseFloat(e.target.value) > 5) {
            updateValue(item.key, 5);
            return;
        }
        if (parseFloat(e.target.value) < 0) {
            updateValue(item.key, 0);
            return;
        }
        if (e.target) {
            updateValue(item.key, e.target.value);
        }
    }

    componentDidMount() {
        const { values, item, updateSliderBackground } = this.props;
        const value = values[item.key];
        updateSliderBackground(value, item.key);
    }

    render() {
        const { item, prefix, open, values, selectedKey, toggle, keyFor, min, max, step } = this.props;
        const key = keyFor(prefix, item);
        const isOpen = !!open[key];
        const value = values[item.key];

        return (
            <li key={key} className={'in-context-menu-item' + (selectedKey === item.key ? ' is-selected' : '')}>
                <div className="in-context-menu-label">
                    <button
                        type="button"
                        className="in-context-menu-button"
                        onClick={() => toggle(key)}
                    >
                        {item.name}
                    </button>
                    <button
                        type="button"
                        className="in-context-toggle"
                        onClick={() => toggle(key)}
                        aria-label={isOpen ? 'Collapse' : 'Expand'}
                    >
                        {isOpen ?
                            <i className="spark-icon-arrow-chevron-down spark-icon--fill" /> :
                            <i className="spark-icon-arrow-chevron-up spark-icon--fill" />
                        }
                    </button>
                </div>
                <div className={'in-context-submenu' + (isOpen ? ' open' : '')}>
                    <div className='in-context-color-label pt-1'>
                        {item.name} (rem)
                    </div>
                    <div className="in-context-slider-container">
                        <input
                            type="range"
                            min={min || "0"}
                            max={max || "5"}
                            step={step || 0.1}
                            value={value}
                            onChange={this.updateValueHandler}
                            className='in-context-slider'
                            id={`in-context-slider-${item.key}`}
                        />
                        <input
                            type="number"
                            step={step || 0.1}
                            min={min || "0"}
                            max={max || "5"}
                            value={value}
                            onChange={this.updateValueHandler}
                            className="in-context-input no-spinners"
                        />
                    </div>
                </div>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/panels/RangePanel.js